/* eslint-disable import/no-anonymous-default-export */
export default {
  "us": {
    "gameServers": "https://server.rush.elbet.us:8003"
  },
  "retail": {
    "gameServers": "https://server.rush.elbet.com:8003"
  },
  "default": {
    "gameServers": "https://server.rush.elbet.com:8003"
  }
}